const MISC_CONSTANTS = {
    membershipPrice: '$135',
    dateFormat: 'MMM d, y',
    fieldDateFormat: 'yyyy-MM-dd',
    RACES_DASHBOARD: 'dashboard',
    BUSINESS_DASHBOARD: 'business_dashboard',
};

export default MISC_CONSTANTS;
